import React from 'react';
import PropTypes from 'prop-types';
import styles from './FileIcon.scss';
import extensionColors from './ExtensionColors';

const FileIconComponent = ({ type, width, height, background }) => {
  const iconStyles = {};
  const cornerStyles = {};
  const typeStyles = {};
  if (width || height) {
    iconStyles.width = width ||
      height.match(/^(\d+)/)[0] * 0.75 + height.match(/([a-z]+)$/)[0];
    iconStyles.height = height ||
      width.match(/^(\d+)/)[0] * 4 / 3 + width.match(/([a-z]+)$/)[0];
    const scale = iconStyles.width.match(/^(\d+)/)[0] / 30;
    Object.assign(typeStyles, {
      bottom: `${6 * scale}px`,
      height: `${10 * scale}px`,
      width: `${20 * scale}px`,
      lineHeight: `${10 * scale}px`,
      fontSize: `${6 * scale}px`,
      left: `${-2 * scale}px`
    });
    Object.assign(cornerStyles, {
      borderLeftWidth: `${10 * scale}px`,
      borderTopWidth: `${10 * scale}px`,
    });
  }
  if (background) cornerStyles.borderTopColor = background;

  if (extensionColors[type]) typeStyles.background = extensionColors[type];
  return (
    <div className={styles.fileTypeIcon} style={iconStyles}>
      <span className={styles.corner} style={cornerStyles} />
      <span className={styles.type} style={typeStyles}>{type}</span>
    </div>
  );
};

FileIconComponent.propTypes = {
  background: PropTypes.string,
  labelColor: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  type: PropTypes.string.isRequired
};

export default FileIconComponent;



// WEBPACK FOOTER //
// ./webpack/components/Elements/FileIcon/FileIcon.js